module.exports = __webpack_public_path__ + "img/EarningIcon.3853ca09.svg";